import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Icon from "@mdi/react";
import { mdiPencil, mdiPlus } from "@mdi/js";
import In from "Resources/ImagesNew/print-alt-5-white.png";
import moment from "moment";
import { getBranch } from "utils/utils";

export const BtnInDanhSachRp = ({ }) => {
    const dispatch = useDispatch();
    const listDonHang = useSelector((state) => state.listDanhSachDonDatHang);
    const dataSearch = useSelector((state) => state.dataSearchDanhSachDonDatHang);

    const Print = () => {
        if (getBranch() == 0 || getBranch() == "0") {
            console.log(getBranch(), "getBranch()getBranch()getBranch()");
            const cate = { ...listDonHang };
            var strBranch = "";
            // Set lai gia tri khi click
            cate.List2.map((row, i) => {
                if (row.IsCheck === 1) {
                    strBranch = strBranch + "_" + row.BranchID;
                }
            });

            window.location.href =
                "/PrintsFile/ListDonDatHangRp?fromDate=" +
                moment(dataSearch.tuNgay).format("YYYY-MM-DD") +
                "&toDate=" +
                moment(dataSearch.denNgay).format("YYYY-MM-DD") +
                "&sSearch=" +
                dataSearch.sSearch +
                "&sCustomerName=" +
                dataSearch.sCustomerName +
                "&iTrangThaiTruKho=" +
                dataSearch.iTrangThaiTruKho +
                "&iTrangThaiThanhToan=" +
                dataSearch.iTrangThaiThanhToan +
                "&iBranch=" +
                getBranch() +
                "&sBranch=" +
                strBranch +
                "&sNVKDUserName=" +
                dataSearch.sNVKDUserName +
                "&lstNhomKH=" +
                dataSearch.lstNhomKH +
                "&iLoaiDon=" +
                dataSearch.iLoaiDon +
                "&iLoaiDoiTac=" +
                dataSearch.iLoaiDoiTac +
                "&iPageIndex=1&iPageSize=200000" +
                "&typeDate=" +
                dataSearch.typeDate +
                "&sTrangThai=" +
                dataSearch.sTrangThai;
        } else {
            window.location.href =
                "/PrintsFile/ListDonDatHangRp?fromDate=" +
                moment(dataSearch.tuNgay).format("YYYY-MM-DD") +
                "&toDate=" +
                moment(dataSearch.denNgay).format("YYYY-MM-DD") +
                "&sSearch=" +
                dataSearch.sSearch +
                "&sCustomerName=" +
                dataSearch.sCustomerName +
                "&iTrangThaiTruKho=" +
                dataSearch.iTrangThaiTruKho +
                "&iTrangThaiThanhToan=" +
                dataSearch.iTrangThaiThanhToan +
                "&iBranch=" +
                getBranch() +
                "&sBranch=" +
                dataSearch.sBranch +
                "&sNVKDUserName=" +
                dataSearch.sNVKDUserName +
                "&lstNhomKH=" +
                dataSearch.lstNhomKH +
                "&iLoaiDon=" +
                dataSearch.iLoaiDon +
                "&iLoaiDoiTac=" +
                dataSearch.iLoaiDoiTac +
                "&iPageIndex=1&iPageSize=200000" +
                "&typeDate=" +
                dataSearch.typeDate +
                "&sTrangThai=" +
                dataSearch.sTrangThai;
        }
    };
    return (
        <>
            <button
                className="button-Icon-text bg-blue-main mr-2 button-in-new"
                onClick={Print}
            // disabled={doubleClick}
            >
                <img src={In} title="In" alt="" />
                In
            </button>
        </>
    );
};
